import { render, staticRenderFns } from "./WeekdayPrices.vue?vue&type=template&id=8051c038&scoped=true"
import script from "./WeekdayPrices.vue?vue&type=script&lang=js"
export * from "./WeekdayPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8051c038",
  null
  
)

export default component.exports